export const translation = {
    title: 'Migrations',
    migrateToProject: 'Migrate to Project',
    findMigrationPlaceholder: 'Type to find a Migration…',
    migrationDisabled: 'It is not possible to export Import Job or Data Source sheet',
    flowDiagram: {
        empty: '<p>Start migrating your DMX project by <br /><strong>drag and dropping</strong> the ZIP file here or <br /></p><p><UploadButton /> locally.</p>'
    },
    upload: {
        button: 'Upload'
    },
    createDialog: {
        title: 'Create New Migration',
        name: 'Name'
    },
    migrateToProjectDialog: {
        title: 'Create New Migration',
        configure: 'Configure Migration',
        newProject: 'New Project',
        existingProject: 'Existing Project',
        chooseProject: 'Choose an existing project…',
        projectDetails: 'Project Details'
    },
    card: {
        sheets: 'Sheets',
        datasources: 'Datasources',
        exports: 'Exports'
    },
    inspector: {
        mappings: 'Migrated to:'
    },
    filters: {
        inOut: 'Inputs/Outputs',
        everything: 'Everything'
    },
    migrated: 'Migrated',
    inventory: {
        columns: {
            name: 'Sheet Name',
            type: 'Sheet Type',
            sheetId: 'Sheet Id',
            details: 'Details',
            targetProjects: 'Migrated To'
        },
        findNode: 'Find a node…'
    },
    entityBrowser: {
        title: 'Entity Browser',
        emptyState: 'Upload ZIP file to start migrating your DMX project.'
    },
    loading: 'Loading items…',
    migrateDialog: {
        title: 'Create New Migration',
        migrated: 'Migrated',
        errors: 'Errors',
        inProgress: '<b>Migration in Progress:</b> Status information will be shown as it becomes available.',
        completed: '<b>Migration Process Completed:</b> Click below to navigate to the newly migrated project.',
        goToProject: 'Go to Migrated Project',
        cancel: '$t(common:cancel)',
        columns: {
            name: 'Name',
            status: 'Status',
            type: 'Type',
            error: 'Error'
        },
        status: {
            succeeded: 'Migrated',
            failed: 'Failed',
            pending: 'Pending'
        }
    }
};
